import { Flex } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
import { useGetSource, useGetUtmSource } from '../../../../common/hooks/useQueryParams';
import LoansFollowupForm from '../../../../pages/LoansFollowupForm/user';
import { LoansFormEvents } from '../../types';
import { StepperState } from '../LoanFormStepper';

const DocumentUpload = ({ loanData, goNext }: StepperState) => {
  const utmSource = useGetUtmSource();
  const source = useGetSource();
  const { trackEvent } = useEventTracker();
  const onSubmit = () => {
    trackEvent({
      event: LoansFormEvents.CompletedDocumentUpload,
      data: {
        rp_id: loanData.recruitmentPartnerId,
        utm_source: utmSource,
        source: source,
        id: loanData.id,
      },
    });
    goNext();
  };
  return (
    <Flex justify="center" width="fill">
      <LoansFollowupForm loanId={loanData.id} onSubmit={onSubmit} />
    </Flex>
  );
};

export default DocumentUpload;
